import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BASE_URL } from '../../global';
import { environment } from '../../../environments/environment';
import {
  CustomerInfoSearch,
  CustomerOfficeList,
  CustomerOfficeDetail,
  CustomerJobOrder,
  Approver,
  UpdateApproverEmail
} from '../models/customer-info.model';

@Injectable({
  providedIn: 'root'
})
export class CustomerInfoService {
  private apiUrl = environment.useApiGateway
    ? `${environment.apiGatewayUrl}/customerinfo`
    : BASE_URL + '/CustomerInfo';

  constructor(private http: HttpClient) { }

  searchCustomerOffices(search: CustomerInfoSearch): Observable<CustomerOfficeList[]> {
    let params = new HttpParams();
    if (search.branchId) {
      params = params.set('branchId', search.branchId.toString());
    }
    if (search.customerName) {
      params = params.set('customerName', search.customerName);
    }
    return this.http.get<CustomerOfficeList[]>(`${this.apiUrl}/search`, { params });
  }

  getCustomerOfficeDetailById(customerOfficeId: number): Observable<CustomerOfficeDetail> {
    return this.http.get<CustomerOfficeDetail>(`${this.apiUrl}/detail/${customerOfficeId}`);
  }

  getCustomerOfficeDetailByCode(code: string): Observable<CustomerOfficeDetail> {
    const params = new HttpParams().set('code', code);
    return this.http.get<CustomerOfficeDetail>(`${this.apiUrl}/detail-by-code`, { params });
  }

  getJobOrders(customerOfficeId: number): Observable<CustomerJobOrder[]> {
    return this.http.get<CustomerJobOrder[]>(`${this.apiUrl}/job-orders/${customerOfficeId}`);
  }

  getApprovers(customerOfficeId: number): Observable<Approver[]> {
    return this.http.get<Approver[]>(`${this.apiUrl}/approvers/${customerOfficeId}`);
  }

  checkEmailDuplicate(userId: number, email: string): Observable<boolean> {
    const params = new HttpParams()
      .set('userId', userId.toString())
      .set('email', email);
    return this.http.get<boolean>(`${this.apiUrl}/check-email-duplicate`, { params });
  }

  updateApproverEmail(data: UpdateApproverEmail): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/update-approver-email`, data);
  }

  resetApproverEmail(userId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/reset-approver-email/${userId}`, {});
  }

  resetPassword(userId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/reset-password/${userId}`, {});
  }
}
